import {Component} from '@angular/core';
import {ErrorStateMatcher} from '@angular/material';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import * as $ from 'jquery';
import * as firebase from 'firebase';
import {ActivatedRoute, Params} from '@angular/router';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

export class FirebaseService {
  public firebase;


  constructor() {
    this.init();
  }

  init() {
    // ========= GLOBAL DECLARATIONS ============
    const config = {
      'apiKey': 'AIzaSyDjB9RSBqKywjMxe5c2HyiLKTrfzLZ8dSc',
      'authDomain': 'charlotteapp-f3d14.firebaseapp.com',
      'databaseURL': 'https://charlotteapp-f3d14.firebaseio.com',
      'projectId': 'charlotteapp-f3d14',
      'storageBucket': 'charlotteapp-f3d14.appspot.com',
      'messagingSenderId': '9708939609',
    };

    firebase.initializeApp(config);

    this.firebase = firebase;

    // https://charlotteapp-f3d14.firebaseapp.com/__/auth/
    // action?
    // mode=resetPassword
    // &oobCode=uZcyEml-aCeK8Ki9er-ZlVFQaKlMZxTE9rOueef1Kk0AAAFhvi_Avg
    // &apiKey=AIzaSyAWueNPkzGfqii2ffSNi7qUhsKI0_7gEBo
  }
}

function validatePasswords(c: FormControl) {

  // console.log(c);

  return $('#newPW').val() === $('#confirmPW').val() ? null : {
    validatePasswords: {
      valid: false
    }
  };
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  passwordFormControl = new FormControl('', [
    Validators.required,
    Validators.minLength(8),
  ]);

  matcher = new MyErrorStateMatcher();
  passwordConfirmFormControl = new FormControl('', [
    Validators.required,
    validatePasswords
  ]);
  newPW: '';
  confirmPW: '';
  private resetCode: any;
  validCode = false;
  showExpired = false;
  submitted = false;

  constructor(private fb: FirebaseService, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      // console.log(params);

      this.resetCode = params['oobCode'];

      if (this.resetCode) {
        this.checkCode(this.resetCode);
      }
    });
  }

  submitForm(pwreset: HTMLFormElement) {
    // console.log(pwreset);
    this.resetPassword(this.newPW, this.resetCode);
  }

  formIsInvalid() {
    const toReturn = (
      (
        this.passwordFormControl.invalid
        || this.passwordConfirmFormControl.invalid
        || this.newPW !== this.confirmPW
      )
    );

    // console.log(toReturn);

    return toReturn;
  }

  checkCode(resetCode: string) {
    // console.log('Checking:', resetCode);
    this.fb.firebase.auth().verifyPasswordResetCode(resetCode)
      .then(email => {
        // console.log('Success', email);
        this.validCode = true;
      })
      .catch(error => {
        // console.log('Invalid code', error);

        this.showExpired = true;
        // this.validCode = true;
      });
  }

  resetPassword(newPW, code) {
    this.fb.firebase.auth().confirmPasswordReset(code, newPW)
      .then(() => {
        // console.log('Success');
        this.validCode = false;
        this.submitted = true;
      })
      .catch((error) => {
        // console.log('Failed', error);
      });
  }
}



// WEBPACK FOOTER //
// C:/Users/srocha/Dropbox/Projects/Charlotte Products/CharlottePasswordReset/src/app/app.component.ts